//#region components/modal/modal_constants.js
var e = {
	default: "",
	danger: "d-modal--danger"
}, t = {
	default: "",
	full: "d-modal--full"
}, n = {
	error: "d-modal__banner--critical",
	info: "d-modal__banner--info",
	success: "d-modal__banner--success",
	warning: "d-modal__banner--warning",
	base: "d-modal__banner--general"
};
//#endregion
export { n as MODAL_BANNER_KINDS, e as MODAL_KIND_MODIFIERS, t as MODAL_SIZE_MODIFIERS };

//# sourceMappingURL=modal-constants.js.map